const STORE_CHANGE_BAR_DISMISSED_KEY = "store-change-bar-dismissed";

// Classes for add-to-cart and checkout buttons to hide when store is not for India but visitor is in India
const ADD_TO_CART_AND_CHECKOUT_BUTTONS_SELECTORS = [
  ".product-form__buttons",
  ".product-card__add-to-cart--form",
  ".product-recommendations",
  "#select_custom_size_btn",
  ".product-card__add-to-cart--button",
  ".product-form__submit",
  '[name="checkout"]',
];

const LATE_LOADING_SELECTORS = [".wpe-card__add, .wpe-card__cart-btn"];

class StoreChangeBar extends HTMLElement {
  constructor() {
    super();
    if (Shopify.designMode) {
      window.addEventListener("shopify:section:load", this.init.bind(this));
    }
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this._initialized) return;
    this._initialized = true;
    this.storeRegion = Shopify.currency.active === "USD" ? "Global" : "India";
    this.checkRegionAndShowAnnouncementBar();
    this.querySelector("[data-store-change-bar-close]")?.addEventListener(
      "click",
      this.dismiss.bind(this),
    );
  }

  dismiss() {
    this.classList.remove("show");
    try {
      sessionStorage.setItem(STORE_CHANGE_BAR_DISMISSED_KEY, "true");
    } catch (e) {}
  }

  shouldRestrictPurchasing(storeRegion, country) {
    // User from India browsing global store → restrict add to cart / checkout
    if (storeRegion === "Global") return country === "IN";
    return false;
  }

  hidePurchaseButtons() {
    ADD_TO_CART_AND_CHECKOUT_BUTTONS_SELECTORS.forEach(function (btn) {
      document.querySelectorAll(btn).forEach(function (el) {
        if (el) {
          el.style.display = "none";
        }
      });
    });

    function hideLate() {
      LATE_LOADING_SELECTORS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          el.style.display = "none";
        });
      });
    }

    hideLate();

    const observer = new MutationObserver(hideLate);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  async getVisitorCountry() {
    const url = "https://get.geojs.io/v1/ip/country.json";

    const response = await fetch(url);
    const data = await response.json();
    return data?.country || null;
  }

  shouldShowForRegion(storeRegion, country) {
    if (storeRegion === "always") return true;
    if (storeRegion === "India") return country !== "IN";
    // User from India browsing global store → show bar
    if (storeRegion === "Global") return country === "IN";
    return true;
  }

  async checkRegionAndShowAnnouncementBar() {
    const self = this;

    try {
      if (sessionStorage.getItem(STORE_CHANGE_BAR_DISMISSED_KEY) === "true")
        return;
    } catch (e) {}

    const country = await this.getVisitorCountry();
    if (!self.shouldShowForRegion(self.storeRegion, country)) return;

    if (self.shouldRestrictPurchasing(self.storeRegion, country)) {
      self.hidePurchaseButtons();
    }
    self.classList.add("show");
    document.documentElement.style.setProperty(
      "--store-change-bar-height",
      this.offsetHeight + "px",
    );
  }
}

customElements.define("store-change-bar", StoreChangeBar);
